import * as globals from '@wandb/weave/common/css/globals.styles';
import styled, {css} from 'styled-components';

import {ReportPanelGridSection as ReportPanelGridSectionComp} from '../../../ReportPanelGridSection';

export const PanelGridWrapper = styled.div``;

export const ReportPanelGridSection = styled(ReportPanelGridSectionComp)<{
  readOnly: boolean;
}>`
  margin-top: 12px !important;
  white-space: normal;
  ${props =>
    !props.readOnly &&
    css`
      .grid-section-wrapper {
        cursor: pointer;
        &:hover {
          .grid-dot {
            background: ${globals.THEME.bgHover};
          }
        }
      }
    `}

  .grid-section-wrapper,
  .run-sets-wrapper {
    padding: 0 !important;
  }
`;

export const PanelGridErrorWrapper = styled.div`
  padding: 60px 0;
  margin: 12px 64px;
  color: ${globals.THEME.textSecondary};
  text-align: center;
  align-items: center;
  justify-content: center;
  border: 1px solid ${globals.THEME.border};
  display: flex;
`;

export const ErrorImageWrapper = styled.img`
  max-width: 400px;
  flex-direction: column;
  align-items: center;
  margin-right: 12px;
`;

export const ErrorMessageWrapper = styled.div`
  line-height: 20px;

  h1 {
    font-size: 20px;
    margin-bottom: 10px;
  }

  a {
    color: ${globals.THEME.textSecondary};
    font-weight: 600;
  }
`;
